import { MainMapPlaceService } from '@bvt-features/mainmap/place/service';
import { STORE_PREFIX } from '@bvt-features/tenant-suitability/constant/STORE_PREFIX';

const { createAsyncThunk } = require('@reduxjs/toolkit');

const mainMapPlaceService = new MainMapPlaceService();

const asyncActionCheckMarkerIsValid = createAsyncThunk(
  `${STORE_PREFIX}/droppable-marker/check-area`,
  async ({ latitude, longitude, id_source }, { rejectWithValue }) => {
    try {
      const placeData = await mainMapPlaceService.get_coordinates({
        meta: {
          filter: {
            id_source: id_source,
            longitude: longitude,
            latitude: latitude,
          },
        },
      });
      return placeData;
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export { asyncActionCheckMarkerIsValid };
